/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownAwardStatus } from '../models/db_DropdownAwardStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AwardStatuses {
    /**
     * Get a list of award statuses
     * @returns db_DropdownAwardStatus OK
     * @throws ApiError
     */
    public static listAwardStatuses(): CancelablePromise<Array<db_DropdownAwardStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/award-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
